"use strict";
/**
 * @author Click Creative <support@clickcreative.com.au>
 * @author Simone Bosco <simone@clickcreative.com.au>
 * @copyright 2016 Click Creative
 * @package SASWater/Template
 * @since 05/2017
 */

export default () => {

    var form = $('.js-quickquoteform');
    var quotes = [];
    var quoteWidgetStep1 = $('.js-quotetemplate');
    var selectedQuote = [];

	(function ($) {
		$(document).ready(function () {
			console.log("App start!");
			var homeSlider = $('.js-home-slider');
			homeSlider.owlCarousel({
				items: 1,
				loop: true,
				autoplay: true,
				autoplayTimeout: 7000,
				autoplayHoverPause: false,
				animateIn: 'fadeIn',
				animateOut: 'fadeOut',
				lazyLoad: true,
				nav: false
			});

			$(".carousel").slick({
				// normal options...
				infinite: false,
				arrows: true,
				prevArrow: $('.prev'),
				nextArrow: $('.next'),
				// the magic
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						infinite: true
					}

				}, {

					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						dots: true
					}

				}, {

					breakpoint: 300,
					settings: "unslick"

				}]
			});

			$(".resources-carousel").slick({
				// normal options...
				infinite: false,
				arrows: true,
				prevArrow: $('.r-prev'),
				nextArrow: $('.r-next'),
				dots: true,
				// the magic
				responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						infinite: true
					}

				}, {

					breakpoint: 600,
					settings: {
						slidesToShow: 1,
						dots: true
					}

				}, {

					breakpoint: 300,
					settings: "unslick"

				}]
			});

			createAccordion($('.js-faq-accordion-group'), {
				header: ".js-accordiongrouphead",
			});

			createAccordion($('.js-faq-accordion'), {
				header: ".js-accordionhead",
			});

			//Menu
			$('.js-toggle-burger-menu').on('click', function () {
				$('.js-menu').addClass('active');
				$('body').addClass('menuShown');
			});
			$('.js-close-menu').on('click', function () {
				$('.js-menu').removeClass('active');
				$('body').removeClass('menuShown');
			});
			// $('.js-toggle-secondary-menu').on('mouseover', function (e) {
			// 	if ($(this).data('id')) {
			// 		e.preventDefault();
			// 		$('.js-second-level-menu').removeClass('active');
			// 		$('.js-toggle-secondary-menu').parent().removeClass('active');
			// 		$('#' + $(this).data('id')).addClass('active');
			// 		$(this).parent().addClass('active');
			// 	}
			// });
            $('.js-toggle-secondary-menu').on('click', function (e) {
                e.preventDefault();
                $(this).next().toggleClass('active');
            });

			//Location Page
			$('.js-show-location').on('click', function (e) {
				e.preventDefault();
				$('.js-show-location').parent().removeClass('active');
				$('.js-location-details').find('.js-location-details-container').removeClass('active');
				$(this).parent().addClass('active');
				$('.js-location-details').find('#' + $(this).data('detail')).addClass('active');

				$('html,body').animate({scrollTop: $('.js-location-details').offset().top}, 'slow');
			});

			function createAccordion($el, opts) {
				var defaults = {
					active: false,
					collapsible: true,
					heightStyle: "content",
					icons: false
				};
				$.extend(defaults, opts);
				$el.accordion(defaults);
			}

			var loginLink = $('.js-log-in-link');
			loginLink.on('click', function (e) {
				e.preventDefault();
				$(this).slideUp();
				$('.js-login-container').slideDown();
			});

			var loginFailDialog = $('.js-login-fail-dialog');
			if (loginFailDialog.length) {
				alert("Invalid username or password. Please try again or contact the adminstrator.");
			}

			var quickQuoteForm = $('.js-quickquoteform'),
				quickQuoteResults = $('.js-quickquoteresults'),
				quickQuoteClose = $('.js-closequickquote'),
				quickQuoteOpen = $('.js-openquickquote'),

				quickOrigin = $(".js-pickuplocation"),
				quickDest = $(".js-deliverylocation"),

				quickVehType = $(".js-quickvehicletype"),
				accountNo = $(".js-getDetailsFrom"),
				pageBody = $("body");
			quickQuoteOpen.on('click', function (ev) {
				ev.preventDefault();
				quickQuoteForm.validate({
					submitHandler: function (form) {
						if (quickOrigin.val() == quickDest.val()) {
							alert('Origin Depot and Destination Depot must be different');
							return false;
						}
						// quickQuoteResults.addClass('loading');
						// quickQuoteResults.find('.js-results').html('');
						quickQuoteResults.fadeIn('300');
						pageBody.addClass('quick-quote-active');

						getQuotes();
					}
				});
				quickQuoteForm.submit();
			});

			quickQuoteClose.on('click', function (ev) {
				ev.preventDefault();
				quickQuoteResults.fadeOut('300');
				pageBody.removeClass('quick-quote-active');
				window.location.reload();
			});

			var loadQuoteTrigger = $('.js-load-existing-quote');
			loadQuoteTrigger.on('click', function () {
				event.preventDefault();
				$('.js-load-quote-section').toggleClass('active');
			});

			if (sessionStorage.getItem("topAlertMessage")) {
				$('.top-alert-block').slideUp(800);
				//$('.js-vertical-menu').removeClass('top-alert-block-active');
			} else {
				$('.top-alert-block').show();
				//$('.js-vertical-menu').addClass('top-alert-block-active');
			}

			var topAlertBlockClose = $('.js-top-alert-close-btn');
			if (topAlertBlockClose.length) {
				topAlertBlockClose.on('click', function (event) {
					$('.top-alert-block').slideUp(800);
					//$('.js-vertical-menu').removeClass('top-alert-block-active');
					sessionStorage.setItem("topAlertMessage", true);
				});
			}

			// select account dropdown
			if ($('.js-getDetailsFrom').length) {
				var data = $('.js-getDetailsFrom').data("accountinfo");

				var preselectedAcc = $('.js-getDetailsFrom').data("preselected"); // for loading quote function

				if (preselectedAcc) { // for loading quote function
					$('.js-getDetailsFrom').val(preselectedAcc);
					$.ajax({
						type: "POST",
						url: '/home/setSelectedAccCusNo',
						data: {
							AccCusNo: preselectedAcc,
						},
						success: function (data) {
							console.log("Account changed");
						}
					});
				} else {
					$('input[name="ContactEmail"]').val(data.Email);
					// var names = data.Name.split(" ");
					// $('input[name="ContactFirstName"]').val(names[0]);
					// $('input[name="ContactSurname"]').val(names[1]);
					// $('input[name="ContactPhone"]').val(data.Phone);
					// $('input[name="ContactMobile"]').val(data.Mobile);
				}

				$('.js-getDetailsFrom').on('change', function (ev) {
					var choice = $(this).val();
					// Set account customer number to make quotes and booking with
					// Call ajax to a function to update account customer number
					$.ajax({
						type: "POST",
						url: '/home/setSelectedAccCusNo',
						data: {
							AccCusNo: choice,
						},
						success: function (data) {
							console.log("Account changed");
						}
					});
				});
			}

			// quotes-widget
			if (quickQuoteResults.length) {
				var quotesWidgetStep1 = $('.js-quotes-widget-step-1');
				var quotesWidgetStep2 = $('.js-quotes-widget-step-2');

				$('.js-quotes-widget-next').on('click', function (e) {
					e.preventDefault();

					var link = $(this).data('quote-page');
					if (selectedQuote.length > 0 || Object.keys(selectedQuote).length > 0) {
						pageBody.removeClass('quick-quote-active');
						var url = link + '?PickUpLocation=' + quickOrigin.val() + '&DeliveryLocation=' + quickDest.val();
						window.location.href = url;
					}

					// quotesWidgetStep1.hide();
					// quotesWidgetStep2.show();
				});

				$('.js-quotes-widget-back').on('click', function (e) {
					e.preventDefault();
					quotesWidgetStep1.show();
					quotesWidgetStep2.hide();
				});
			}
		});
	})(jQuery);

    function getQuotes() {
        var quoteTableContainer = $('.js-quotes-table-container');
        var quickQuoteResults = $('.js-quickquoteresults');
        var vehiclesArr = [];
        var quotesWrapper = $('.js-quotesloadingwrapper').addClass('loading');

        $.ajax({
            type: "POST",
            url: 'quote/getQuickQuotes',
            data: {
                PickUpLocation: form.find('.js-pickuplocation').val(),
                DeliveryLocation: form.find('.js-deliverylocation').val(),
                AccountNo: form.find('.js-getDetailsFrom').val(),
                Vehicles: getVehiclesFormData()
            },
            dataType: 'json',
            success: function (data) {
                quotes = data;
                var isEmptyRated = false;

                if (data && data.length && (isEmptyRated != true)) {
                    $.each(data, function (index, quoteData) {
                        populateQuoteEl(quoteData);
                    });
                    populateNullQuote();
                } else {
                    populateNullQuote();
                }
            }
        });
    };

    function getVehiclesFormData() {
        var vehicles = [];
        var vehicleData = {};
        vehicleData['VehicleRateCode'] = form.find('.js-quickvehicletype').val();
        vehicleData['VehicleRateCodeTitle'] = form.find(".js-quickvehicletype option:selected").text();
        vehicles.push(vehicleData);
        return vehicles;
    }

    function populateQuoteEl(quoteData) {
        var template = $('.js-quotetemplate');
        template.find('.js-quote').each(function (index) {
            if (
                quoteData.deliveryType == parseInt($(this).data('deliverytype')) &&
                quoteData.pickUpType == parseInt($(this).data('pickuptype'))
            ) {

                $(this).find('[data-servicetype=' + quoteData.service + '] .js-quote-cost').html(quoteData.totalNice);
                $(this).find('[data-servicetype=' + quoteData.service + '] .js-transit-days').html('Transit Days: ' + quoteData.transitDays);
                $(this).find('.js-quotepickup').html('<i>' + quoteData.pickUp + '</i>').addClass('locationtype-' + quoteData.pickUpType);
                $(this).find('.js-quotedelivery').html('<i>' + quoteData.delivery + '</i>').addClass('locationtype-' + quoteData.deliveryType);
                // var quoteInput = $(this).find('.js-quoteselection');
                // var quoteInputLabel = $(this).find('.js-quoteselectionlabel');
                var quoteInput = $(this).find('[data-servicetype=' + quoteData.service + ']').find('.js-quoteselection');
                var quoteInputLabel = $(this).find('[data-servicetype=' + quoteData.service + ']').find('.js-quoteselectionlabel');
                quoteInput.val(quoteData.uniqueId);
                quoteInput.attr('id', 'Quote-' + quoteData.uniqueId);
                $(this).find('[data-servicetype=' + quoteData.service + ']').addClass('visible');

                quoteInput.on('change', function (ev) {
                    updateQuoteSelection();
                });
                quoteInputLabel.attr('for', 'Quote-' + quoteData.uniqueId);

            }
        });
    };

    function updateQuoteSelection() {
        // var selectedEl1 = CommonQuote.quoteWidgetStep1.find('.js-quoteselection');
        var selectedEl = quoteWidgetStep1.find('.js-quoteselection:checked');

        //Add class to selected quote
        quoteWidgetStep1.find('.js-quote').removeClass('active');
        selectedEl.parents('.js-quote').addClass('active');

        var quoteId = selectedEl.val();


        var quoteData = getQuoteById(quoteId);
        var trkService = (typeof quoteData.service == 'string') && quoteData.service.length ? quoteData.service : 'Not Set';
        // gtag('event', 'quote selection', {event_category: 'quote', event_label: trkService});


        if (quoteData) {
            selectedQuote = quoteData;
            $.ajax({
                type: "POST",
                url: 'quote/selectQuickQuote',
                data: {
                    SelectedQuote: quoteData,
                },
                dataType: 'json',
                success: function (data) {

                }
            });

        }
    };

    function getQuoteById(id) {
        if (quotes && quotes.length) {
            var matching = $.grep(quotes, function (quoteData) {
                return quoteData.uniqueId == id;
            });
            if (matching.length) {
                return matching[0];
            }
        }
        return false;
    };

    function populateNullQuote() {
        var template = $('.js-quotetemplate');
        template.find('.cost-col').each(function (index, quoteCell) {
            if (!$(quoteCell).hasClass('visible')) {
                $(quoteCell).html('N/A');
                $(quoteCell).addClass('visible');
            }
        });
    };

    var tooltipField = $('.js-tooltip-field > input[type="text"]');

    tooltipField.focus(function(){
        $(this).parent().addClass("tooltip-active");
    }).keydown(function(){
        $(this).parent().removeClass("tooltip-active");
    }).blur(function(){
        $(this).parent().removeClass("tooltip-active");
    })

    $('.js-banner-scroll').click(function() {
        var currentSectionHeight = $('.js-home-banner').outerHeight();
        $('html, body').animate({
            scrollTop: currentSectionHeight + 89
        }, 800);
    });
}

